import { authGuard, guestGuard } from '@core/firebase';
import { adminGuard } from '@core/guards/admin.guard';
import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [authGuard('/signin')],
    data: { breadcrumb: null },
    loadComponent: () =>
      import('./core/components/layout/sidenav/sidenav.component').then(
        (mod) => mod.SidenavComponent
      ),
    children: [
      // 舊的admin基底導向為新版去除admin的版本
      { path: 'admin', redirectTo: '', pathMatch: 'prefix' },
      // 預設頁面：服務對象
      { path: '', redirectTo: 'cases', pathMatch: 'full' },

      {
        path: 'personnel-schedule',
        data: { breadcrumb: '班級負責人查詢' },
        loadComponent: () =>
          import('./department/personnel-schedule/personnel-schedule.component').then(
            (mod) => mod.PersonnelScheduleComponent
          ),
      },
      //申請表
      {
        path: 'applications',
        loadChildren: () => import('./application/application.routes'),
      },
      //服務對象
      { path: 'cases', loadChildren: () => import('./case/case.routes') },
      // 待簽收件匣
      {
        path: 'sign-off',
        data: { breadcrumb: '待簽核' },
        loadComponent: () =>
          import('./sign-off/sign-off-inbox/sign-off-inbox.component').then(
            (mod) => mod.SignOffInboxComponent
          ),
      },
      // 表單填寫紀錄
      {
        path: 'form-completion',
        loadChildren: () => import('./form-completion/form-completion.routes'),
      },
      // 生理量測
      {
        path: 'physiological',
        loadChildren: () => import('./physiological/physiological.routes'),
      },
      // 問卷發送
      {
        path: 'survey',
        loadChildren: () => import('./survey/survey.routes'),
      },
      // 匯出
      {
        path: 'export',
        loadChildren: () => import('./export/export.routes'),
      },
      // 空白表單下載
      {
        path: 'downloads',
        loadChildren: () => import('./download/download.routes'),
      },
      // 人員管理
      {
        path: 'personnel',
        loadChildren: () => import('./personnel/personnel.routes'),
      },
      // 系統管理
      {
        path: 'manage',
        canActivate: [adminGuard('/')],
        loadChildren: () => import('./manage/manage.routes'),
      },
      // 系統文件
      {
        path: 'docs',
        loadChildren: () => import('./docs/docs.routes'),
      },
      {
        path: 'contact',
        data: { breadcrumb: '聯絡我們' },
        loadComponent: () =>
          import('./contact/contact.component').then((mod) => mod.ContactComponent),
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/components/layout/guest-layout/guest-layout.component').then(
        (mod) => mod.GuestLayoutComponent
      ),
    children: [
      { path: '', redirectTo: '/signin', pathMatch: 'full' },
      {
        path: 'signin',
        canActivate: [guestGuard('/')],
        data: { breadcrumb: '登入' },
        loadComponent: () =>
          import('./auth/signin/signin.component').then((mod) => mod.SigninComponent),
      },
      {
        path: 'services',
        loadChildren: () => import('./application/apply.routes'),
      },
      {
        path: 'guest',
        loadChildren: () => import('./guest/guest.routes'),
      },
    ],
  },
  {
    path: 'maria-daily-care-privacy',
    data: { breadcrumb: '隱私權保護政策' },
    loadComponent: () =>
      import('./privacy/maria-daily-care-privacy/maria-daily-care-privacy.component').then(
        (mod) => mod.MariaDailyCarePrivacyComponent
      ),
  },
];
